<template>
  <div>
    <div class="row mt-5 mb-5 roboto-style">
      <div class="col-md-3">
        <div class="row">
          <div class="col-md-4 pl-0 pl-lg-3">
            <icn1></icn1>
          </div>
          <div class="col-lg-8 col-md-6 offset-md-1 offset-lg-0 pl-0">
            <p v-bind:class="['m-0 font-weight-bold dark-grey boldnr', {'pt-4' : width > 1027}, {'pt-4' : width <= 1027 && width >= 1023}, {'pt-2' : width < 1023}]">300+</p>
            <p class="m-0 small-description inter-style medium-grey">Successful projects</p>
          </div>
        </div>
      </div>
      <div class="col-md-3 pl-3">
        <div class="row">
          <div class="col-md-4">
            <icn2></icn2>
          </div>
          <div class="col-lg-8 col-md-6 offset-md-2 offset-lg-0 pl-0">
            <p v-bind:class="['m-0 font-weight-bold dark-grey boldnr', {'pt-4' : width > 1027}, {'pt-4' : width <= 1027 && width >= 1023}, {'pt-2' : width < 1023}]">10+</p>
            <p class="m-0 small-description inter-style medium-grey">Years of experience</p>
          </div>
        </div>
      </div>
      <div class="col-md-3 pl-3">
        <div class="row">
          <div class="col-md-4">
            <icn3></icn3>
          </div>
          <div class="col-lg-8 col-md-6 offset-md-2 offset-lg-0 pl-0">
            <p v-bind:class="['m-0 font-weight-bold dark-grey boldnr', {'pt-4' : width > 1027}, {'pt-4' : width <= 1027 && width >= 1023}, {'pt-2' : width < 1023}]">100%</p>
            <p class="m-0 small-description inter-style medium-grey">Client retention</p>
          </div>
        </div>
      </div>
      <div class="col-md-3 pl-3">
        <div class="row">
          <div class="col-md-4">
            <icn4></icn4>
          </div>
          <div class="col-lg-8 col-md-6 offset-md-2 offset-lg-0 pl-0">
            <p v-bind:class="['m-0 font-weight-bold dark-grey boldnr', {'pt-4' : width > 1027}, {'pt-0' : width <= 1027 && width >= 1023}, {'pt-2' : width < 1023}]">2</p>
            <p class="m-0 small-description inter-style medium-grey">Continents available</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
    import icn1 from './icn1';
    import icn2 from './icn2';
    import icn3 from './icn3';
    import icn4 from './icn4';
    export default {
        components: {
            icn1: icn1,
            icn2: icn2,
            icn3: icn3,
            icn4: icn4
        },
        data() {
            return {
                width: 0
            }
        },
        methods: {
            resizeEvent() {
                this.windowWidth = window.innerWidth;
            }
        },
        computed: {
            windowWidth: {
                get: function () {
                    return this.width;
                },
                set: function (val) {
                    this.width = val;
                }

            }
        },
        mounted() {
            this.width = window.innerWidth;
            window.addEventListener('resize', this.resizeEvent);
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.resizeEvent);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/icons_row.vue